import React, { useState, useContext, Fragment } from 'react';
import useFormProcessor from '../../hooks/useFormProcessor';

import { getCookie, setCookie } from '../../utils/cookie';

import { ProjectsContext } from '../../providers/projects-context.provider';

import { deleteProject, updateProject } from '../../services/projects.service';
import { getEmptyInputsErrorsObject } from '../../utils/errors/project';
import { validateKey, validateName } from '../../utils/validations/project';

import ErrorMessageContainer from '../form-input-error-message';
import FormInput from '../form-input';
import NavLink from '../nav-link';
import CardFormContainer from '../card-form-container';
import Tag from '../tag';

const initialIsEditClicked = false;
const initialError = { Name: '', Key: '', BaleId: '' };

const ProjectCard = ({ initialData }) => {
	const {
		data,
		errors,
		setErrors,
		setData,
		handleChange,
		handleOnBlur,
		handleSubmit
	} = useFormProcessor(initialError, {
		...initialData
	});
	const { currentProject, saveCurrentProject, saveUpdatedProjects } = useContext(ProjectsContext);
	const [ isEditClicked, setIsEditClicked ] = useState(initialIsEditClicked);

	const handleUpdate = async () => {
		const { Name, Key, BaleId } = data;
		const token = getCookie('x-auth-token');

		try {
			await updateProject(initialData.Id, { Name, Key, BaleId }, token);
			saveUpdatedProjects();
		} catch (error) {
			console.log(error);
		}
	};

	const handleDeleteClick = async () => {
		const token = getCookie('x-auth-token');

		try {
			var updatedToken = await deleteProject(token, initialData.Id);

			if (currentProject && currentProject.Id === initialData.Id) {
				saveCurrentProject(null);
			}

			setCookie('x-auth-token', updatedToken);
			saveUpdatedProjects();
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<CardFormContainer
			showEdit={data.IsCurrentUserCreator}
			isEditClicked={isEditClicked}
			setIsEditClicked={setIsEditClicked}
			initialData={initialData}
			initialError={initialError}
			setData={setData}
			setErrors={setErrors}
			handleDeleteClick={handleDeleteClick}
			handleSubmit={(e) =>
				handleSubmit(e, getEmptyInputsErrorsObject({ Name: data.Name, Key: data.Key, BaleId: data.BaleId }), handleUpdate)}
		>
			<div className="pt-1">
				{!isEditClicked ? (
					<NavLink
						to={`/user/dashboard/${data.Id}/backlog`}
						hoverColor="green-400"
						otherClasses="cursor-pointer text-xl text-gray-900 leading-tight"
					>
						{data.Name}
					</NavLink>
				) : (
					<div>
						<FormInput
							autoFocus
							className="focus:outline-none p-1 pl-2 text-xl text-black leading-tight"
							type="text"
							name="Name"
							value={data.Name}
							onChange={handleChange}
							handleOnBlur={(event) => handleOnBlur(event, validateName, { Name: data.Name })}
							placeholder="Project Name"
						/>
						{errors.Name ? <ErrorMessageContainer>{errors.Name}</ErrorMessageContainer> : null}
					</div>
				)}

				{!isEditClicked ? (
					<Fragment>
						<p className="mt-1">{data.Key}</p>
						<div>
							{data.IsCurrentUserCreator ? (
								<Tag text="سازنده" color="orange-500" size="w-16 h-4" />
							) : (
								<Tag text="عضو تیم" color="green-500" size="w-16 h-4" />
							)}
						</div>
					</Fragment>
				) : (
					<div>
						<p className="mt-1">
							<FormInput
								className="focus:outline-none p-1 pl-2 text-base text-gray-600 leading-normal"
								type="text"
								name="Key"
								placeholder="Key"
								value={data.Key}
								handleChange={handleChange}
								handleOnBlur={(event) => handleOnBlur(event, validateKey, { Key: data.Key })}
							/>
							{errors.Key ? <ErrorMessageContainer>{errors.Key}</ErrorMessageContainer> : null}
						</p>
						
						<p className="mt-1">
							<FormInput
								className="focus:outline-none p-1 pl-2 text-base text-gray-600 leading-normal"
								type="text"
								name="BaleId"
								placeholder="شناسه گپ"
								value={data.BaleId}
								handleChange={handleChange}
							/>
							
						</p>
					</div>
				)}
			</div>
		</CardFormContainer>
	);
};

export default ProjectCard;
